<template>
    <BoletinView fetch-path="settlementplayer" toolbar-title="Reporte mensual de salarios" :type-label-hide="true"
                 descripion-label="Observación" period></BoletinView>
</template>

<script>
import BoletinView from '../../boletines/views/BoletinView'

export default {
  components: {
    BoletinView
  }
}
</script>
